import { ensureBrowserAuthBootstrap, getBrowserAuthAccessToken } from '../browser-auth'
import type { BrowserFallbackRegistry } from './types'

export const billingBrowserFallbacks: BrowserFallbackRegistry = {
  billing: {
    getSubscription: async () => {
      await ensureBrowserAuthBootstrap()
      return await getBrowserAuthAccessToken().then(() => ({ active: false, isLegacyBilling: false }))
    },
  },
}
